


















import { Component, Vue, Ref } from 'vue-property-decorator'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import IntroModal from './components/IntroModal.vue'
import ResultModul from './components/ResultModul.vue'
import ChickenStable from './components/ChickenStable.vue'

@Component({
  components: {
    ResultModul,
    ChickenStable,
    IntroModal
  }
})
export default class App extends Vue {
  @Ref('chickenStable') readonly stable!: ChickenStable
  showResults = false
  normalNumber = 0
  organicNumber = 0
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  targetElement: any

  getNumbers(normal: number, organic: number) {
    this.normalNumber = normal
    this.organicNumber = organic
  }

  handleResultModal(val: boolean) {
    if (val) {
      enableBodyScroll(this.targetElement)
    } else {
      disableBodyScroll(this.targetElement)
    }
    this.showResults = val
  }

  restartGame() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.stable.resetChicken()
    this.showResults = false
  }

  mounted() {
    this.targetElement = document.querySelector(
      '.stable_container__organic_stable__dropzone__sqm'
    )
    disableBodyScroll(this.targetElement)
  }
}
